import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino', 'bingo'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'This site is operated by Playbook Gaming Ltd, trading as Playbook Engineering Ltd, (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. No.1 Poultry, London EC2R 8EJ.',
        licence_number: '50122',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/50122',
        cookies_url: 'https://planetsportbet.com/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-MHWH8B7',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'Planet Sport Bet',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Featured Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtMzUwMzEyOkItcDEtMC02OGU2MWUxOS0wLTMwMmMwMjE0NmYxZTA4ZTNkMzQwMDEyODI5YzkxNzA2OGVjZWJjN2FmNGIxZjljNDAyMTQyNjAyYWFiM2RmYzZlNmIzYjRkYTBjYjZkMmJhZWJkNWRlZDY3ODQ5',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003231852',
            EUR: '', // TODO - add this value when ready: https://portals.paysafe.com/portal/developer/webhooks
        },
        openBanking: 'yaspa',
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        AffiliateDashboard: 'AffiliateDashboard-PlanetSportBet/Overview-DB',
        BackofficeReports: 'BackOfficeReports-PlanetSportBet/DB-Casino',
        BlockedPlayersReport: 'Players-PlanetSportBet/BlockedPlayersReport',
        BonusEngine: 'BonusEngine-PlanetSportBet/CampaignLevel',
        BespokeReports: 'BespokeReports-PlanetSportBet/HorseRacingData',
        CasinoDashboard: 'CasinoDashboard-PlanetSportBet/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-PlanetSportBet/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-PlanetSportBet/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-PlanetSportBet/DailyKPI',
        RacecourseDashboard: 'Racecourse-PlanetSportBet/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-PlanetSportBet/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-PlanetSportBet/AccountBalances',

        PlatformOverview: 'Overview-PlanetSportBet/Overview',
        // TradingOverview: 'Trading-PlanetSportBet/Overview',
        Segmentation: 'Segmentation-PlanetSportBet/LapsedEmailSportsCustomersDashboard',
        MarketingOverview: 'Marketing-PlanetSportBet/Overview',
        PaymentsOverview: 'Payments-PlanetSportBet/Overview',
        LiftetimeValue: 'LifetimeValue-PlanetSportBet/LiftetimeValue',
        RollingNetDeposits: 'RollingNetDeposits-PlanetSportBet/RollingNetDeposits',
        Accounts: 'Accounts-PlanetSportBet/Overview',
    },
};
